// 一些常用的配置
const HTML_INPUT_TIME_FORMAT = 'YYYY/MM/DD HH:mm:ss'
const HTML_INPUT_DATE_FORMAT = 'YYYY/MM/DD'
const HTML_INPUT_TIMEONLY_FORMAT = 'HH:mm:ss'
const HTML_INPUT_MONTH_DATE = 'YYYY/MM'

export { HTML_INPUT_TIME_FORMAT, HTML_INPUT_DATE_FORMAT, HTML_INPUT_TIMEONLY_FORMAT, HTML_INPUT_MONTH_DATE }
